module.exports = __webpack_public_path__ + "img/FotoMo3.ee868f41.png";